import { TextColorLight, TextHighlightColor } from "@wix/wix-ui-icons-common";
import lodash from "lodash";
import { Decoration_Type } from "./../ricos-types/index.js";
import { getHighlightColorInSelection } from "./../_shared/resolvers/get-highligh-color-in-selection.js";
import { getTextColorInSelection } from "./../_shared/resolvers/get-text-color-in-selection.js";
import { isAlwaysVisible } from "./../_shared/resolvers/is-always-visible.js";
import { isNodeSelected } from "./../_shared/resolvers/is-node-selected.js";
import { TEXT_COLOR_MODAL_ID, TEXT_HIGHLIGHT_MODAL_ID } from "./constants.js";
import { TEXT_BUTTON_TEXT_COLOR, TEXT_BUTTON_TEXT_HIGHLIGHT } from "./data-hooks.js";
import classes from "./text-button-color-scss.js";
import { TextColorPicker } from "./TextColorPicker.js";
const getTextColorTextButtons = (config = {}) => {
  return [
    {
      id: `${Decoration_Type.COLOR}.foreground`,
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_TEXT_COLOR,
        tooltip: "TextColorButton_Tooltip",
        getIcon(publicCommands) {
          const color = publicCommands.getColor("ricos-text-color");
          return () => TextColorLight({
            className: classes.textColorIcon,
            style: { "--ricos-internal-text-color": color }
          });
        }
      },
      attributes: {
        visible: isAlwaysVisible,
        selectedTextColor: getTextColorInSelection,
        disabled: isNodeSelected
      },
      command: ({ referenceElement, modalService }) => () => {
        modalService.isModalOpen(TEXT_COLOR_MODAL_ID) ? modalService.closeModal(TEXT_COLOR_MODAL_ID) : openColorModal({
          modalId: TEXT_COLOR_MODAL_ID,
          modalType: "ricos-text-color",
          modalService,
          config,
          referenceElement
        });
        return true;
      }
    }
  ];
};
const getTextHighlightTextButtons = (config = {}) => {
  return [
    {
      id: `${Decoration_Type.COLOR}.background`,
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_TEXT_HIGHLIGHT,
        tooltip: "TextHighlightButton_Tooltip",
        getIcon(publicCommands) {
          const color = publicCommands.getColor("ricos-text-highlight");
          return () => TextHighlightColor({
            className: classes.textHighlightIcon,
            style: { "--ricos-internal-text-highlight": color }
          });
        }
      },
      attributes: {
        visible: isAlwaysVisible,
        selectedHighlightColor: getHighlightColorInSelection,
        disabled: isNodeSelected
      },
      command: ({ referenceElement, modalService }) => () => {
        modalService.isModalOpen(TEXT_HIGHLIGHT_MODAL_ID) ? modalService.closeModal(TEXT_HIGHLIGHT_MODAL_ID) : openColorModal({
          modalId: TEXT_HIGHLIGHT_MODAL_ID,
          modalType: "ricos-text-highlight",
          modalService,
          config,
          referenceElement
        });
        return true;
      }
    }
  ];
};
const openColorModal = ({
  modalId,
  modalType,
  modalService,
  referenceElement,
  config
}) => {
  modalService.openModal({
    id: modalId,
    Component: TextColorPicker,
    componentProps: {
      referenceElement,
      type: modalType,
      config
    },
    layout: {
      desktop: referenceElement ? "floating" : "dialog",
      mobile: "drawer"
    },
    noPadding: true,
    ...referenceElement && {
      positioning: { placement: "bottom", referenceElement }
    },
    onClickOutside: {
      on: "pointerup",
      handler: lodash.noop
    },
    returnFocusToEditor: true,
    disableArrowNavigation: true,
    dragHandleSelector: "[data-drag-handler]",
    enableDrag: true,
    withTransition: true
  });
};
export {
  getTextColorTextButtons,
  getTextHighlightTextButtons,
  openColorModal
};
//# sourceMappingURL=getTextButtons.js.map
